import { inject, Injectable } from '@angular/core';
import { UnleashFlags, UnleashService } from '@thiememeulenhoff/ng-sdk';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ResourceStatusEndpointService {
  readonly #service = inject(ServicesService);

  readonly #unleash = inject(UnleashService);

  #backendUrl(endpoint: string) {
    if (
      this.#unleash.isEnabled(UnleashFlags.UseVestaArrangements) &&
      this.#unleash.isEnabled(UnleashFlags.ResourcesOnContentIdentifier)
    ) {
      return this.#service.vesta(endpoint);
    }

    return this.#service.thip(endpoint);
  }

  groupResourceStatus(groupCode: string, arrangementCode: string) {
    return this.#backendUrl(
      `arrangement/${arrangementCode}/resource/status/group/${groupCode}`,
    );
  }

  storeResourceStatus(arrangementCode: string) {
    return this.#backendUrl(`arrangement/${arrangementCode}/resource/status`);
  }
}
